export const getAllExperimentsAndVariants = () => {
  const experiments = Object.keys(localStorage)
    .filter((key) => key.startsWith('amp-exp-'))
    .reduce(
      (acc: Record<string, { experiment: string; variant: string }>, key) => {
        const value = JSON.parse(localStorage.getItem(key) || '')
        Object.keys(value).forEach((innerKey) => {
          if (value[innerKey].key !== 'off') {
            acc[innerKey] = {
              experiment: innerKey,
              variant: value[innerKey].key
            }
          }
        })
        return acc
      },
      {} as Record<string, { experiment: string; variant: string }>
    )

  const filteredExperiments = Object.values(experiments).filter(
    (item) => item !== null && item !== undefined
  )

  return filteredExperiments
}
